import { useState } from "react";
import type { FaqItem } from "@/types/content";

interface Props {
  items: FaqItem[];
  defaultOpen?: number;
}

export default function FaqAccordion({ items, defaultOpen = 0 }: Props) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpen);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item, index) => {
        const open = openIndex === index;
        return (
          <div key={item.question}>
            <h3>
              <button
                type="button"
                aria-expanded={open}
                onClick={() => setOpenIndex(open ? null : index)}
                className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-background-100 cursor-pointer md:px-6 md:py-5"
              >
                <span className="font-heading text-sm font-bold text-foreground-900 md:text-base">
                  {item.question}
                </span>
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                  <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-base`}></i>
                </span>
              </button>
            </h3>
            {open && (
              <div className="px-4 pb-5 md:px-6">
                <p className="text-sm leading-relaxed text-foreground-600">{item.answer}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}